const payManager = new function () {
    this.initChooser = (addr) => {
        var chooser = new DPDChooser('dpdchooser', {
            type: 'dpdclient', // Обязательный параметр
            //Геопозиция:
            address: addr, //Адрес (Можно передавать сокращенно – только город, а можно с учетом страны, города, улицы)
            //l: 'Москва', //Адрес можно передавать короткими параметрами (город)
            //s: 'Нахимовский проспект', //Адрес можно передавать короткими параметрами (улица)
            //m: 'Крымская', //Адрес можно передавать короткими параметрами (метро)
            //g: '43.928704,56.280332', //Можно вместо адреса передавать координаты: долгота, широта (имеет бОльший приоритет, чем адрес)
            // После загрузки данных происходит центрирование на переданной геопозиции. Если ни один пункт не попадает на карту, то карта отдаляется до 4х раз
            // Если передан большой по площади объект для центрирования (например, вся Москва), то границы карты будут установлены так, чтобы весь объект попал в область видимости.
            //i: '111402' //центрирование по индексу
            viewdistance: 100, // Радиус отображения пунктов в километрах вокруг указанного адреса

            //Фильтры:
            /*filter_fromh: 10, // - число время ОТ
            filter_toh: 12, // - число время ДО
            filter_maxweight: 10, // Вес самой тяжелой посылки (кг)
            filter_dimmensionsum: 50, // Сумма габаритов (см)
            filter_dimmensionmax: 30, // Максимальный габарит (см)
            filter_wait: 1, // Ожидание на адресе доставки
            filter_temp: 0, // Температурный режим
            filter_cod: 0, // Наложенный платеж
            filter_give: 0, // Выдача посылок
            filter_take: 0, // Прием посылок
            filter_pvz: 0, // Пункт приема и выдачи посылок
            filter_postamat: 0, // Постамат*/

            //Возможность выбора пункта.
            choose: 1, //Если не передано - виджет работает только для просмотра, без кнопки «Выбрать»

            //width: '700px', // Можно указать css ширину контейнера. Пример: 500px, 100%, 50em
            //mapHeight: '500', // Можно указать высоту карты в пикселях. Пример: 500.
            //ВНИМАНИЕ!!! Высота касается только карты, списка пунктов и детализации. Это НЕ высота всего контейнера виджета.
            //Задать высоту виджета нельзя, т.к. детализация может "прыгнуть" вниз из-за нехватки места в ширину.
            fullscreen: true, // Задает width = 100% и mapHeight в зависимости от window.innerHeight. Позволяет виджету занять всё пространство контейнера, если достаточно места. Должно быть не менее 400px в высоту и не менее 500px в ширину.

            //Авторизация.
            sid: 'aGloYGlpbGxpbSVubhtuamBpGGEdbxtvam5gbRocHxxrHWlsHBsaGG1hHxpgaB8dbmxqXg=='
            /*
                Чтобы получить sid и скрыть свои авторизационные данные из HTML страницы нужно сделать следующее:
                1. Получить уникальный ключ клиента – для этого необходимо зайти в личный кабинет(MyDPD) по адресу http://www.dpd.ru/ols/order/personal/integrationKey.do2   указав свой логин и пароль. На странице нужно нажать на кнопку «отправить» и ключ будет выслан на указанный e-mail. Если у Вас возникли трудности с получением ключа, обращайтесь в службу поддержки по адресу itcustomers@dpd.ru;
                2. Послать серверный запрос на http://chooser.dpd.ru/getsid.php?icn=<ваш_клиентский_номер>&key=<ваш_ключ>
                3. Сервер отдаст строчку SID, которую нужно подставить в параметр sid виджета.
                Эту строчку можно получить единожды. Не обязательно слать запрос каждый раз перед показом виджета на странице.
            */
        });

        chooser.onError(function (error, code) {
            document.getElementById('console').innerHTML = 'Ошибка чузера (' + error + ') код ' + code + '<br>';
            /*
             Возможные коды ошибок:
             -2: Переданный контейнер не существует
             -1: Не передан контейнер
             1: Ошибка валидации
             2: Не удалось определить адрес.
             3: Для данного города нет пунктов.
             4: Ошибка авторизации.
             5: Недостаточно места для полного экрана.
             */
        });

        chooser.onReady(function (address) {
            document.getElementById('console').innerHTML = 'Чузер готов. Адрес: ' + address + '<br>';
        });

        chooser.onChoose(function (dep) {
            // document.getElementById('console').innerHTML = 'Выбран пункт ' + dep;
            $('#chooseEndpointModal').modal('hide');
            $('#endPointInput').val(dep.addressString);
            $('#endPointBtn').text('Изменить');
            //console.log(dep)
        });
    }

    this.checkCity = () => {
        const cityId = $('#cityInput').attr('data-kladr-id') || null
        if (!cityId) {
            $('#cityInput').addClass('is-invalid')
        } else {
            $('#cityInput').removeClass('is-invalid')
        }
        return cityId
    }

    this.changeDelivery = (val) => {
        // console.log(val)
        $('#form-address').hide()
        $('#form-endpoint').hide()
        if (val == 1) {
            $('#form-address').show()
        }
        if (val == 2) {
            $('#form-endpoint').show()
            this.showChooseEndpoint()
        }
        this.checkDelivery()
    }

    this.showChooseEndpoint = () => {
        if (this.checkCity()) {
            $('#chooseEndpointModal').modal('show');
            this.initChooser('Россия, ' + $('#cityInput').val())
        }
    }

    this.checkDelivery = () => {
        let check = true
        $('#deliveryFieldset').removeClass('is-invalid')
        if (!$('#deliveryType1').prop('checked') && !$('#deliveryType2').prop('checked')) {
            check = false
            $('#deliveryFieldset').addClass('is-invalid')
        }
        return check
    }

    this.checkForm = () => {
        let check = !!this.checkCity()
        const email = $('#inputEmail').val()

        const validateEmail = (email) => {
            return String(email)
                .toLowerCase()
                .match(
                    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                );
        }

        $('#inputEmail').removeClass('is-invalid')
        $('#inputPhone').removeClass('is-invalid')
        $('#inputFio').removeClass('is-invalid')

        if (!email || !validateEmail(email)) {
            check = false
            $('#inputEmail').addClass('is-invalid')
        }

        let phone = $('#inputPhone').val() || ''

        phone = phone.replace('(','').replace(')','')
            .replace(/\-/g,'')
            .replace(/\+/g,'')
            .replace(/s/g,'')

        if (!(/8\d{10}/.test(phone)) && !(/7\d{10}/.test(phone))) {
            check = false
            $('#inputPhone').addClass('is-invalid')
        }

        if (!$('#inputFio').val()) {
            check = false
            $('#inputFio').addClass('is-invalid')
        }

        const checkDelivery = this.checkDelivery()
        check = check && checkDelivery

        $('#offerCheckWrap').removeClass('is-invalid')
        if (!$('#offerCheck').prop('checked')) {
            check = false
            $('#offerCheckWrap').addClass('is-invalid')
        }

        const delivery1 = $('#deliveryType1').prop('checked')
        const delivery2 = $('#deliveryType2').prop('checked')

        $('#streetInput').removeClass('is-invalid')
        if ((!$('#streetInput').val() || $('#streetInput').hasClass('kladr-error')) && delivery1) {
            check = false
            $('#streetInput').addClass('is-invalid')
        }

        $('#buildingInput').removeClass('is-invalid')
        if ((!$('#buildingInput').val() || $('#buildingInput').hasClass('kladr-error'))  && delivery1) {
            check = false
            $('#buildingInput').addClass('is-invalid')
        }

        $('#endPointInput').removeClass('is-invalid')
        if (!$('#endPointInput').val() && delivery2) {
            check = false
            $('#endPointInput').addClass('is-invalid')
        }

        return check
    }

    this.onInputCity = (obj) => {
        if (obj.contentType == 'city') {
            if (this.checkCityAjax) {
                this.checkCityAjax.abort()
                this.checkCityAjax = null
            }
            this.checkCityAjax = $.post('/api/testCity', {id: obj.id} , function(response) {
                // Log the response to the console
                if (response.result == 'ok') {
                    $('#deliveryFieldset').removeAttr('disabled')
                    $('#cityMessage').text('Выберите город')
                } else {
                    $('#cityMessage').text('В этот город доставка невозможна')
                    $('#cityInput').removeAttr('data-kladr-id')
                    $('#cityInput').addClass('is-invalid')
                }
            });
            const cityId = this.checkCity()
            // console.log('onInputCity', cityId)
        }
    }

    this.initKladr = () => {
        const $container = $(document.getElementById('form-wrap'));

        const $tooltip = $('#tooltip');

        const // $zip = $container.find('[name="zip"]'),
            // $region = $container.find('[name="region"]'),
            // $district = $container.find('[name="district"]'),
            $city = $container.find('[name="city"]'),
            $street = $container.find('[name="street"]'),
            $building = $container.find('[name="building"]');
        $()
            // .add($region)
            // .add($district)
            .add($city)
            .add($street)
            .add($building)
            .fias({
                parentInput: $container,
                verify: true,
                select: (obj) => {
                    /* if (obj.zip) {
                        $zip.val(obj.zip);//Обновляем поле zip
                    }  */
                    $tooltip.hide();
                    this.onInputCity(obj)
                },
                check: (obj) => {
                    if (obj) {
                        $tooltip.hide();
                        this.onInputCity(obj)
                    }
                },
                /*checkBefore: (obj) => {
                    var $input = $(this);

                    if (!$.trim($input.val())) {
                        $tooltip.hide();
                        return false;
                    }
                }*/
            });

        $city.fias('type', $.fias.type.city);
        $street.fias('type', $.fias.type.street);
        $building.fias('type', $.fias.type.building);

        $city.fias('withParents', true);
        $street.fias('withParents', true);

        // Отключаем проверку введённых данных для строений
        // $building.fias('verify', false);
    }

    this.submitForm = (ev) => {
        ev.preventDefault()

        if (this.checkForm()) {
            this.calcPrice()
            $('#pay-form').submit()
        }
    }

    this.productPrice = 4900
    this.productDiscont = 2000

    this.calcPrice = () => {
        const count = $('#productCount').val() || 1
        const total = this.productPrice * count

        const newTotal = total - (count - 1) * this.productDiscont

        $('#orderTotal').text(newTotal)
        $('#orderTotalOld').text(total)

        if (count > 1) {
            $('#orderTotalOld').show()
        } else {
            $('#orderTotalOld').hide()
        }

        $('#totalPriceInput').val(newTotal)
        $('#totalCountInput').val(count)
    }
}

window.payManager = payManager